<template>
  <div class="container page">
    <van-nav-bar class="nav-bar" :title="$t('修改真实姓名')">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="$router.back()"/>
      </template>
      <template #right>
        <span class="nav-right" @click="save()">{{ $t('保存') }}</span>
      </template>
    </van-nav-bar>
    <van-cell-group>
      <van-field v-model="name" :readonly="userInfo.name !== ''" :label="$t('姓名')"
                 :placeholder="$t('请输入真实姓名')"/>
    </van-cell-group>
    <!--<p>{{ $t('为了您账户安全,真实姓名需要与绑定银行卡姓名一致') }}</p>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      userInfo: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    save() {
      if (this.userInfo.name) {
        this.$toast(this.$t("请勿重复设置") + "！");
        return true;
      }
      if (this.name === "" || this.name === null || this.name === undefined) {
        this.$toast.fail(this.$t("请输入姓名") + "！");
        return false;
      }
      this.$http({
        method: 'get',
        data: {name: this.name},
        url: 'user_set_name'
      }).then(res => {
        if (res.code === 200) {
          this.getUserInfo();
          this.name = this.userInfo.name;
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.van-cell {
  font-size: 35px;
  line-height: 80px;
}

.container p {
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  // 导航栏PC端适配
  .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar {
    line-height: 57px !important;
  }

  ::v-deep .van-nav-bar__content {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
    max-width: 60% !important;
  }

  ::v-deep .van-nav-bar .van-icon {
    font-size: 26px !important; /* 45px * 0.5733 ≈ 26px */
  }

  ::v-deep .nav-right {
    font-size: 17px !important; /* 30px * 0.5733 ≈ 17px */
  }

  // 内容区域PC端适配
  .van-cell {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
    line-height: 46px; /* 80px * 0.5733 ≈ 46px */
  }

  .container p {
    padding: 0 9px; /* 15px * 0.5733 ≈ 9px */
    margin-top: 9px; /* 15px * 0.5733 ≈ 9px */
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
  }
}
</style>
